import Avatar from "@mui/material/Avatar"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Slide from "@mui/material/Slide"
import Typography from "@mui/material/Typography"
import { Text } from "components/text"
import useHeadingStyles from "hooks/useHeadingStyles"
import useRelativeTime from "hooks/useRelativeTime"
import moment, { Moment } from "moment-timezone"
import { useEffect, useState } from "react"

interface ScheduledMeetingCardProps {
  institution: any
  startAt: Moment
  endAt: Moment
  formattedStartTime: any
  meetingHost: any
  meetingRegistration: any
  onMeetingLaunchPress: any
  onMeetingRemovePress: any
}

const ScheduledMeetingCard = (props: ScheduledMeetingCardProps): JSX.Element => {
  const {
    institution,
    startAt,
    endAt,
    formattedStartTime,
    meetingHost,
    meetingRegistration,
    onMeetingLaunchPress,
    onMeetingRemovePress,
  } = props

  const [checked, setChecked] = useState(true)

  useEffect(() => {
    if (!checked) {
      onMeetingRemovePress()
    }
  }, [checked])

  const { classes: headingClasses } = useHeadingStyles()
  const meetingRelativeTime = useRelativeTime({ startAt, endAt })

  const isMeetingLive = meetingRelativeTime.during
  const isMeetingInFuture = meetingRelativeTime.before
  const isMeetingPast = meetingRelativeTime.after

  const onCancel = () => {
    setChecked(false)
  }

  return (
    <Slide direction="right" in={checked} mountOnEnter unmountOnExit>
      <Box
        key={`meeting-registration-${meetingRegistration.id}`}
        flexDirection="column"
        width={["100%"]}
        mt={[1, "10px"]}
        mb={[5, "30px"]}
        mx="0px"
        px="25px"
        py="10px"
        justifyContent="Box-start"
        alignItems="space-between"
        flexWrap="wrap"
        style={{
          background: "linear-gradient(to bottom, #FCFCFC, #EAEAEA)",
          borderRadius: 10,
        }}>
        <Box
          flexDirection={["column", "column", "row"]}
          flexWrap={["wrap"]}
          justifyContent={["center", "space-between", "space-between"]}
          width={["100%"]}
          my={["5px"]}>
          <Box width={["100%"]} mt={[0]}>
            <Box>
              <Box>
                <Typography variant="h2" className={headingClasses.h4}>
                  {institution.name}
                </Typography>
                <Text preset="bodyMediumPrimary" text={formattedStartTime} />
              </Box>
            </Box>
          </Box>
          <Box width={["100%"]} mt={[0]}>
            <Box display="flex" width={["100%"]} justifyContent="space-between" flexWrap="wrap">
              {meetingHost && (
                <Box width={["100%", "60%", "33%"]} pt={[3]}>
                  <div style={{ display: "inline-block" }}>
                    <Avatar alt={meetingHost.first_name} src={meetingHost.avatar.thumb_url} />
                  </div>
                  <div style={{ display: "inline-block", paddingLeft: 15 }}>
                    <Text
                      preset="bodySmallPrimary"
                      text={`${meetingHost.first_name} ${meetingHost.last_name}`}
                    />
                    {Boolean(meetingHost.title) && (
                      <Box mb={[2]}>
                        <Text text={meetingHost.title} />
                      </Box>
                    )}
                  </div>
                </Box>
              )}
              <Box
                display="flex"
                justifyContent={["flex-start", "center", "center"]}
                width={["100%", "40%", "20%"]}
                pt={["10px", "10px", "15px"]}>
                {isMeetingLive && (
                  <Box style={{ width: "100%" }}>
                    <Button
                      variant="contained"
                      style={{ width: "100%", maxWidth: "250px" }}
                      onClick={onMeetingLaunchPress}>
                      JOIN
                    </Button>
                  </Box>
                )}
                {isMeetingInFuture && (
                  <Text
                    preset="bodySmallPrimary"
                    text={`Meeting starts ${moment(meetingRegistration.start_at).fromNow()}!`}
                    style={{
                      width: "100%",
                      textAlign: "left",
                      fontStyle: "italic",
                    }}
                  />
                )}
                {isMeetingPast && (
                  <Text
                    preset="bodySmallPrimary"
                    text={`This meeting has ended.`}
                    style={{
                      width: "100%",
                      textAlign: "left",
                      fontStyle: "italic",
                    }}
                  />
                )}
              </Box>
              <Box
                display="flex"
                justifyContent="flex-end"
                width={["100%", "200px", "200px"]}
                minWidth="200px"
                pt={[3]}>
                {!isMeetingPast && (
                  <Button
                    color="primary"
                    variant="outlined"
                    onClick={onCancel}
                    style={{ height: 50 }}>
                    Cancel
                  </Button>
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Slide>
  )
}

export default ScheduledMeetingCard
